import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log("Route changed:", pathname);
    // Attempt smooth scroll using window.scrollTo
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    
    // Fallback: also set scrollTop on documentElement and body
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // If your scrollable container is not the window,
    // you might need to target that container instead.
    // Example: document.getElementById("scroll-container").scrollTop = 0;
    
  }, [pathname]);

  return null;
};

export default ScrollToTop;
